export const HOST_PREFIX = 'https://';

// export const HOST_SUFFIX = 'exz9q3otfc.execute-api.us-east-1.amazonaws.com/demo/';
export const HOST_SUFFIX = 'pf42lr9w68.execute-api.us-east-1.amazonaws.com/demo/';


// export const HOST_PREFIX = 'http://';
// export const HOST_SUFFIX = 'localhost:3000/';
